module.exports = __webpack_public_path__ + "img/about_us_banner_pc.8c9f2397.png";